<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker :disabled="item.approveType == 1" format="dd.MM.yyyy" size="small" id="starDate" type="date"
          :clearable="false" v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker :disabled="item.approveType == 1" format="dd.MM.yyyy" size="small" id="endDate" type="date"
          :clearable="false" v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 15px;margin-top:31px">
        <el-button size="small" :title="$t('Axtarış')" type="primary" icon="el-icon-search" @click="getData"></el-button>
      </div>
      <div class="col-md-8 col-12">
        <el-radio-group @change="getData" v-model="item.approveType">
          <el-radio :label="1">{{$t('Təsdiq_gözləyənlər')}} </el-radio>
          <el-radio v-if="roles.includes('Director of ICD')" :label="0">{{$t('0-1000_AZN_aralığı')}}</el-radio>
          <el-radio :label="2">{{$t('Təsdiq_edilənlər')}}</el-radio>
        </el-radio-group>
      </div>
      <div class="col-md-4 col-12">
        <el-input size="small" :placeholder="$t('Axtar')" v-model="search"> </el-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-table v-loading="loading" :data="data.filter(
          (data) =>
            !search ||
            (data.claimNumber && data.claimNumber.toLowerCase().includes(search.toLowerCase())) ||
            (data.regNumber && data.regNumber.toLowerCase().includes(search.toLowerCase()))
        )
          " style="width: 100%">
          
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="row" style="margin-left: 40px; background-color: #f5f5f5; padding: 8px 0;width: 85%;">
                <div class="col-11">
                  <span style="font-size: var(--font-primary); display: inline-block;" v-html="scope.row.signers"></span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('İş_#')" sortable prop="dispClaimNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispClaimNumber }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('İşin_statusu')" width="230">
            <template slot-scope="scope">
              <status-label :type="scope.row.statusTypeId === 151
                ? 'goldenrod'
                : '' || scope.row.statusTypeId === 160
                  ? 'forestGreen'
                  : ''
                " />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column>
          

          <el-table-column :label="$t('DQN')" sortable prop="regNumber" width="120">
          </el-table-column>
          <el-table-column :label="$t('S.A.A')" prop="signerName">
          </el-table-column>
          <el-table-column :label="$t('Məbləğ')" prop="paymentSum" width="100">
          </el-table-column>
          <el-table-column :label="$t('Təsdiq_Status_/_Tarix')" width="160">
            <template slot-scope="scope">
              <div v-if="scope.row.status !== null">
                <i :class="scope.row.status === 1 ? 'fa-solid fa-check' : 'fa-solid fa-ban'"
                  :style="scope.row.status === 1 ? 'color:green' : 'color:red'"></i>
                &nbsp;<span>{{ scope.row.statusDateStr }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button size="small"  v-if="scope.row.status === null" @click="approve(scope.row)" type="text"
                style="padding: 0 !important;color:green" size="mini">
                <i class="fa-solid fa-check" title="Təsdiq"></i>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button size="small"  v-if="scope.row.status === null" @click="reject(scope.row)" type="text"
                style="padding: 0 !important;color:red" size="mini">
                <i class="fa-solid fa-ban" title="İmtina"></i>
              </el-button>
            </template>
          </el-table-column> -->
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button size="small"  @click="viewAct(scope.row)" style="padding: 0 !important">
                <div class="square-icon"> <i class="fa-solid fa-file" title="Çap forması"></i></div>

              </el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button  @click="viewAccident(scope.row)" style="padding: 0 !important" size="mini">
                <i class="fa-solid fa-file-circle-check" title="Qəza məlumatları"></i>
              </el-button>
            </template>
          </el-table-column> -->
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button   @click="handleViewClaim(scope.row.claimId, scope.row.id)" style="padding: 0 !important">
                <div class="square-icon"> <i class="fa-solid fa-square-arrow-up-right"
                    title="İş haqqında məlumatlar"></i></div>

              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleStatusView(scope.row.accidentId,'accident')" style="padding: 0 !important">
                <div class="square-icon"> <i title="Ümumi Statuslar" class="fa-solid fa-timeline"></i></div>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 30, 50, 100, 200]" :page-size="pageSize"
            layout="sizes, prev, pager, next" :total="totalRecords">
          </el-pagination>

        </div>

      </div>
    </div>
    <el-dialog width="78%" top="1vh" :visible.sync="printDialogVisible" center>
      <el-button title="Çap forması" style="margin-bottom: 10px;" id="button" v-print="'#printMe'" type="success"><i
          class="fa-solid fa-print"></i> &nbsp;Çap et
      </el-button>

      <div id="printMe">
        <div v-if="actPrint.policyType === 1 || actPrint.policyType === 0">
          <div v-if="actPrint.zbt === 1">

            <act-print-zbt v-if="actPrint" :value="this.actPrint" />
          </div>
          <div v-else>

            <act-print v-if="actPrint" :value="this.actPrint" />
          </div>
        </div>
        <div v-else>

          <act-print-payment v-if="actPrint" :value="this.actPrint" />
        </div>
      </div>


    </el-dialog>
    <accident-status-view ref="status" />
  </div>
</template>

<script>   
import {
  GetActApprovals
} from "src/services/claim";
import AccidentStatusView from "../components/AccidentStatusView.vue";
import { GetClaimActPrint } from "../../services/common";
import { DateToString, AddMonths, AddDays } from "../../services/helper";
import ActPrint from "../components/ActPrint.vue";
import StatusLabel from "../components/StatusLabel.vue";
import ActPrintZbt from "../components/ActPrintZbt.vue";
import ActPrintPayment from "../components/ActPrintPayment.vue";
// import Signers from "../components/Signers.vue";
export default {
  components: {
    ActPrint,
    StatusLabel,
    ActPrintZbt,
    ActPrintPayment,
    AccidentStatusView
    // Signers
  },
  data() {
    return {
      loading: false,
      data: [],
      search: "",
      pageSize: 100,
      currentPage: 1,
      totalRecords: 0,
      item: {
        startDate: null,
        endDate: null,
        approveType: 1,
      },
      claimId: null,
      actPrint: {},
      printDialogVisible: false,
      uid: this.$store.state.user.id,
      roles: this.$store.state.user.roles,
      rolesToCheck: ["Advisor", "Assistant Chairman", "Director of ICD", "Assistant Director of ICD", "Accident commissar manager", "Inspection commission operator 1", "Inspection commission operator 2", "Manager of ICAD"]
    };
  },
  methods: {
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1
      this.getData();
    },

    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.getData();
    },

    viewAccident(item) {
      let routeData = this.$router.resolve({ path: `/approval/detail/${item.accidentId}/${item.claimId}` });
      window.open(routeData.href, '_blank');
    },
    handleViewClaim(id, actId) {
      let routeData = this.$router.resolve({
        path: `/approval/claim/${id}/${actId}`
      });

      window.open(routeData.href, "_blank");
    },
    handleStatusView(id, type) {
      this.$refs["status"].view(id, type);
    },

    viewAct(data) {
      this.printDialogVisible = true;
      this.claimId = data.claimId
      this.getClaimActPrint(this.claimId).then(() => {
        this.title = document.title;
      });
    },

    getData() {
      this.loading = true;
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      this.item.commandUserId = this.uid;
      this.item.page = this.currentPage;
      this.item.pageSize = this.pageSize;

      for (let role of this.rolesToCheck) {
        if (this.roles.includes(role)) {
          this.item.roleName = role;
          break;
        }
      }
      GetActApprovals(this.item).then((response) => {
        this.loading = false;
        if (response.data.data && response.data.data?.[0]) {
          this.data = response.data.data;
          this.totalRecords = response.data.data?.[0].totalRecords;
        }
      });

      // GetActApprovals(this.item).then((response) => {
      //   this.loading = false;
      //   if (response.data.data) {
      //     const uniqueData = Array.from(new Set(response.data.data.map(a => a.id)))
      //       .map(id => {
      //         return response.data.data.find(a => a.id === id)
      //       });
      //     this.data = uniqueData;
      //     this.totalRecords = uniqueData.length; 
      //   }
      // }).catch(error => {
      //   console.error('Error:', error);
      //   this.loading = false;
      // });

    },
    getClaimActPrint() {
      return new Promise((resolve, reject) => {
        GetClaimActPrint(this.claimId).then((response) => {
          if (response.data) {
            this.actPrint = response.data.data?.[0];
          }
          resolve(this.response);
        }, error => {
          reject(error);
        })
      })
    },
    loadTime() {
      this.item.startDate = AddMonths(new Date(), -6);
      this.item.endDate = AddDays(new Date(), +1);
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}


</style>
